/* eslint-disable no-return-assign */
import SharedBiddingList from 'components/organisms/shared_bidding_list';
import { getBiddings } from 'store/modules/bidding_store/actions';
import { getFollowups } from 'store/modules/followup_store/actions';
import { useLocation } from 'react-router-dom';

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import SharedFollowupList from 'components/organisms/shared_followup_list';
import { FollowupState } from 'store/modules/followup_store/types';
import { BiddingState } from 'store/modules/bidding_store/types';

const SharedBidding = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const dispatch = useDispatch();
  const [biddingLoaded, setBiddingLoaded] = useState<boolean>(false);

  const { followups, request } = useSelector<ApplicationState, FollowupState>(
    (state) => state.session.followups,
  );

  const { biddings } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  useEffect(() => {
    dispatch(
      getBiddings({
        access_token: params.get('access_token'),
        favorite: true,
        activities_list: [],
        page: currentPage,
      }),
    );

    dispatch(
      getFollowups({
        access_token: params.get('access_token'),
        favorite: true,
        activities_list: [],
        page: currentPage,
      }),
    );
  }, [currentPage]);

  useEffect(() => {
    if (followups?.total_entries === 0 && request?.error) {
      window.location.href = '/';
    }
    if (biddings?.total_entries === 0 && biddingLoaded) {
      window.location.href = '/';
    }
  }, [request?.error, biddingLoaded]);

  return (
    <>
      {followups?.total_entries > 0 && (
        <SharedFollowupList currentPage={currentPage} setCurrentPage={setCurrentPage} />
      )}
      {biddings?.total_entries > 0 && (
        <SharedBiddingList
          setBiddingLoaded={setBiddingLoaded}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default SharedBidding;
